import {
    SIGNUP_ERROR,
    SIGNUP_SUCCESS,
    SUBMIT_SIGNUP,
    FINISH_SIGNUP,
    FINISH_SIGNUP_ERROR,
    FINISH_SIGNUP_SUBMIT,
    FINISH_SIGNUP_SUCCESS,
    FINISH_SIGNUP_STEP_SUCCESS
} from '../actionTypes'

const initialState = {
    logMessage: '',
    isLoading: false,
    stepNumber: 1,
    message: null
}

export default (state = initialState, action) => {
    switch(action.type) {
        case SIGNUP_SUCCESS:
            return {
                ...state,
                logMessage: '',
                isLoading: false,
                stepNumber: 2
            }

        case SIGNUP_ERROR:
            return {
                ...state,
                logMessage: action.payload.message,
                isLoading: false
            }

        case SUBMIT_SIGNUP:
            return {
                ...state,
                isLoading: true
            }

        case FINISH_SIGNUP:
            return {
                ...state,
                stepNumber: 2
            }

        case FINISH_SIGNUP_SUBMIT:
            return {
                ...state,
                isLoading: true
            }

        case FINISH_SIGNUP_ERROR:
            return {
                ...state,
                isLoading: false,
                message: action.payload.message
            }

        case FINISH_SIGNUP_SUCCESS:
            console.log(action.payload.step)
            return {
                ...state,
                isLoading: false,
                stepNumber: action.payload.step,
                message: null
            }

        case FINISH_SIGNUP_STEP_SUCCESS:
            return {
                ...state,
                stepNumber: action.payload.step
            }

        default:
            return state
    }
}